/*eslint no-unreachable: "off"*/
/*eslint no-useless-concat: "off"*/
/*eslint no-array-constructor: "off"*/
/*eslint no-unused-vars: "off"*/
export function insertComma(n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
}

/**
  title: "지역별 간이 무선국 수",
  xtitle: "무선국 수",
  ytitle: "지역명",
  chartType: "Multi Series Stacked Bar",
  layOutStyle: "Detail",
  masterName: "무선국 점유율",
  valueFixed: 0,
 */
export function layoutForChart1
(chartLayoutProps,
  {
    cmb_gubun_chart, searchYear
  }
)
{
  let layOutData;

  layOutData =
    '<rMateChart backgroundColor="#FFFFFF" borderStyle="none" >'
    + '<Options>'
    //+ '<Caption fontSize="19" text="' + titleData + chartLayoutProps.title + '  "/>'
    //+ '<Caption fontSize="19" text="' + '타이틀데이터' + '타이틀' + '  "/>'
    + '<Caption fontSize="19" text="' + chartLayoutProps.title + '  "/>'
    //+'<Caption fontSize="19" text="'+titleData+chartBaseData["chart"+i].title+' &lt;a href=javascript:cartDownload(\'chart'+i+'\')&gt;&lt;img src=\'/images/chart/chartsave.png\' title=\'차트이미지저장\'&gt; &lt;/a&gt; &lt;a onclick=cartCsvDownloadcartId(\'chart'+i+'\')&gt;&lt;img  src=\'/images/chart/chart_download.png\' title=\'차트CSV저장\'&gt;&lt;/a&gt; "/>'
    //+ '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + searchYear.substr(0, 4) + '년' + searchYear.substr(4, 2) + '월)"/>'
    + '<SubCaption textAlign="right" fontSize="15" paddingRight="10" text="(' + '2021' + '년' + '12' + '월)"/>'
    + '<Legend defaultMouseOverAction="false"  fontSize="15"/>'
    + '</Options>'
    + '<NumberFormatter id="numfmt" useThousandsSeparator="true"/>'
    + '<Bar3DChart showDataTips="true"' + '' + '>'
    + '<horizontalAxis>'
    //+ '<LinearAxis formatter="{numfmt}" id="hAxis" title="' + chartLayoutProps.xtitle + '" labelJsFunction="labelFuncNum"/>'
    + '<LinearAxis formatter="{numfmt}" id="hAxis" labelJsFunction="labelFuncNum"/>'
    + '</horizontalAxis>'
    + '<horizontalAxisRenderers>'
    + '<Axis3DRenderer axis="{hAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="cross" minorTickPlacement="cross" placement="bottom" canDropLabels="true" showLabels="true" showLine="true" labelAlign="center">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</horizontalAxisRenderers>'
    + '<verticalAxis>'
    //+ '<CategoryAxis id="vAxis" categoryField="gugun" title="' + chartLayoutProps.ytitle + '" labelJsFunction="labelFunc"/>'
    + '<CategoryAxis id="vAxis" categoryField="gugun" labelJsFunction="labelFunc"/>'
    + '</verticalAxis>'
    + '<verticalAxisRenderers>'
    + '<Axis3DRenderer axis="{vAxis}" axisTitleStyleName="title" tickLength="10" minorTickLength="0" tickPlacement="cross" minorTickPlacement="cross" placement="bottom" canDropLabels="false" showLabels="true" showLine="true" labelAlign="center" verticalAxisTitleAlignment="vertical">'
    + '<axisStroke>'
    + '<Stroke weight="10" color="#f4f4f4"/>'
    + '</axisStroke>'
    + '<tickStroke>'
    + '<Stroke weight="1" color="#d2d2d2" alpha="1"/>'
    + '</tickStroke>'
    + '<minorTickStroke>'
    + '<Stroke weight="1" color="#ffffff" alpha="1" caps="square"/>'
    + '</minorTickStroke>'
    + '</Axis3DRenderer>'
    + '</verticalAxisRenderers>'
    + '<series>';
  layOutData +=
    '<Bar3DSet type="stacked" showDataTips="true" labelYOffset="-5">'
    + '<series>';

  if (cmb_gubun_chart === '01') { // 주파수 대역별
      layOutData +=
        '<Bar3DSeries labelPosition="inside" xField="cnt" displayName="' + '무선국 수' + '" styleName="seriesLabel" showValueLabels="[]">'
        + '<showDataEffect>'
        + '<SeriesInterpolate/>'
        + '</showDataEffect>'
        + '</Bar3DSeries>';
  }
  layOutData +=
    '</series>'
    + '</Bar3DSet>';
  layOutData +=
    '</series>'
    + '<annotationElements>'
    + '<CrossRangeZoomer zoomType="vertical"  enableZooming="true" enableCrossHair="false">'
    + '</CrossRangeZoomer>'

/* CrossRangeZoomer 속성 설명
* zoomType : 줌 실행 기준을 정합니다. 유효값 : horizontal, vertical, both
* horizontalLabelFormatter : 십자가의 수평 라인에 붙는 라벨 formatter 입니다.
* verticalLabelFormatter : 십자가의 수직 라인에 붙는 라벨 formatter 입니다.
* enableZooming : zoom 기능 사용 여부를 나타냅니다.
* enableCrossHair : 십자가 표시 여부를 나타냅니다.
* useDualCrossXLabel : 십자가의 수평 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* useDualCrossYLabel : 십자가의 수직 라인에 두개의 라벨을 표시합니다.(듀얼축인 경우 유효)
* verticalLabelPlacement : 수직 라인의 라벨 위치를 지정합니다.(유효값: top, bottom)
* horizontalLabelPlacement : 수평 라인의 라벨 위치를 지정합니다.(유효값 : left, right)
*/
    + '</annotationElements>'
    + '</Bar3DChart>'
    + '<Style>'
    + '.seriesLabel{fontSize:11;color:#ffffff;fontWeight:bold;}'
    + '.title{color : 0x4691E1;fontSize : 15;fontWeight : bold;}'
    + '</Style>'
    + '</rMateChart>';
  return layOutData;
}


window.labelFunc = function (index, value) {
  return '<font size="15">' + value + '</font>';
  return "";
};
window.labelFunc2 = function (index, value) {
  return '<font size="13">' + value + '</font>';
  return "";
};
window.labelFuncNum = function (index, value) {
  return '<font size="15">' + window.insertComma(value) + '</font>';
  return "";
};

window.totalFunc = function (index, data, value) {
  if (index === 3)
    return window.insertComma(value);
  return "";
};

//숫자에 천단위 콤마 찍어 반환하는 함수.
window.insertComma = function (n) {
  var reg = /(^[+-]?\d+)(\d{3})/; // 정규식
  n += "";
  while (reg.test(n))
    n = n.replace(reg, '$1' + "," + '$2');
  return n;
};